/* Drag&Drop appearance fixes v1 — 2026-10-25
   Works on top of dd-appearance-v1 (panel + preferences). It never changes the default
   light theme with default settings.
   1) Dark mode completion: every light-designed section stylesheet on the page gets a dark
      counterpart generated from its own rules (selectors, hover states and media queries kept).
      The result is cached so the next pages paint dark immediately.
   2) Readability guard: in dark or high-contrast mode any text that ends up unreadable
      against its real background is corrected.
   3) Text size: "Büyük yazı" / "Çok büyük" scale every storefront text, not only paragraphs.
   4) Line-clamped text is never cut when text size or line spacing grows. */
(function () {
  'use strict';
  if (window.__ddApFixes) return;
  window.__ddApFixes = true;

  var root = document.documentElement;
  var VERSION = '1';
  var CSS_KEY = 'dd.ap.darkgen.v' + VERSION + '.css';
  var MAP_KEY = 'dd.ap.darkgen.v' + VERSION + '.map';
  var MAX_CACHE = 700000;
  var CACHE_DAYS = 14;
  var PH = 'html[data-dd-theme="dark"]';
  var PB = ':not(#dd-ap-x):not(#dd-ap-y)';
  var SKIP_SELECTOR = /data-dd-|ddap-|ddh4-|dd-footer|dd-ref-utility|dd-reference|announcement|dd-back-to-top|shopify-section-group-header|shopify-section-group-footer|ddhe__|ddcat|ddnn-home|dd-home-blog|shopify-design-mode|color-scheme-|color-background-|color-inverse|color-accent-|::selection|scrollbar/i;
  var MEDIA_SELECTOR = /media|image|img|photo|thumb|visual|logo|avatar|picture|swatch|video|poster|figure/i;
  var BUTTON_SELECTOR = /btn|button|submit|checkout|cta|apply|[-_]add\b/i;
  var EXCLUDE_TREE = '.ddap-widget,script,style,noscript,template,svg,iframe,option';
  var GUARD_EXCLUDE = '.ddh4-mode,[aria-disabled="true"],:disabled';
  var ACCENT = '#bff8ae';
  var ACCENT_HOVER = '#d5ffc8';
  var ACCENT_INK = '#10291f';
  var LIGHT_INK = '#eef6ee';
  var DARK_INK = '#13221a';
  var TEXT_SCALE = { regular: 1, large: 1.12, xlarge: 1.25 };
  var HEADER_SCALE_MAX = 1.08;

  /* ---------- colour helpers ---------- */
  var COLOR_RE = /#[0-9a-f]{3,8}\b|rgba?\([^()]*\)|hsla?\([^()]*\)|\b(?:white|black)\b/gi;
  var NAMED = { white: [255, 255, 255, 1], black: [0, 0, 0, 1], transparent: [0, 0, 0, 0] };

  function hslToRgb(h, s, l) {
    if (s === 0) return [l * 255, l * 255, l * 255];
    function hue(p, q, t) {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    }
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    return [hue(p, q, h + 1 / 3) * 255, hue(p, q, h) * 255, hue(p, q, h - 1 / 3) * 255];
  }

  function rgbToHsl(r, g, b) {
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h = 0, s = 0, l = (max + min) / 2;
    if (max !== min) {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
      else if (max === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h /= 6;
    }
    return [h, s, l];
  }

  function parseColor(input) {
    var s = String(input || '').trim().toLowerCase();
    if (!s) return null;
    if (NAMED[s]) return NAMED[s].slice();
    var m;
    if (s.charAt(0) === '#') {
      var h = s.slice(1);
      if (h.length === 3 || h.length === 4) h = h.split('').map(function (c) { return c + c; }).join('');
      if (h.length !== 6 && h.length !== 8) return null;
      var out = [parseInt(h.substr(0, 2), 16), parseInt(h.substr(2, 2), 16), parseInt(h.substr(4, 2), 16), h.length === 8 ? parseInt(h.substr(6, 2), 16) / 255 : 1];
      return out.some(isNaN) ? null : out;
    }
    if ((m = s.match(/^rgba?\(([^()]*)\)$/))) {
      var p = m[1].split(/[\s,\/]+/).filter(Boolean);
      if (p.length < 3) return null;
      var num = function (v, max) { return /%$/.test(v) ? parseFloat(v) * max / 100 : parseFloat(v); };
      var rgb = [num(p[0], 255), num(p[1], 255), num(p[2], 255), p.length > 3 ? num(p[3], 1) : 1];
      return rgb.some(isNaN) ? null : rgb;
    }
    if ((m = s.match(/^hsla?\(([^()]*)\)$/))) {
      var q = m[1].split(/[\s,\/]+/).filter(Boolean);
      if (q.length < 3) return null;
      var a = q.length > 3 ? (/%$/.test(q[3]) ? parseFloat(q[3]) / 100 : parseFloat(q[3])) : 1;
      var c = hslToRgb(((parseFloat(q[0]) % 360) + 360) % 360 / 360, parseFloat(q[1]) / 100, parseFloat(q[2]) / 100);
      var res = [c[0], c[1], c[2], a];
      return res.some(isNaN) ? null : res;
    }
    return null;
  }

  function fmt(c) {
    var ch = function (v) { return Math.max(0, Math.min(255, Math.round(v))); };
    if (c[3] < 1) return 'rgba(' + ch(c[0]) + ',' + ch(c[1]) + ',' + ch(c[2]) + ',' + (+c[3].toFixed(3)) + ')';
    return '#' + [c[0], c[1], c[2]].map(function (v) { return ('0' + ch(v).toString(16)).slice(-2); }).join('');
  }

  function info(c) {
    var hsl = rgbToHsl(c[0] / 255, c[1] / 255, c[2] / 255);
    return { h: hsl[0], s: hsl[1], l: hsl[2] * 100, ch: Math.max(c[0], c[1], c[2]) - Math.min(c[0], c[1], c[2]) };
  }

  function make(i, l, neutralSat, maxSat, a) {
    var neutral = i.ch < 22;
    var rgb = hslToRgb(neutral ? 150 / 360 : i.h, neutral ? neutralSat : Math.min(i.s, maxSat), Math.max(0, Math.min(100, l)) / 100);
    return [rgb[0], rgb[1], rgb[2], a];
  }

  function mapBg(c) {
    if (!c[3]) return c;
    var i = info(c);
    if (c[3] < 0.35) return make(i, 100 - i.l, 0.08, 0.45, c[3]);
    if (i.l >= 55 && i.ch > 45) return c; // light brand/accent colours stay as they are
    if (i.l >= 50) return make(i, Math.min(32, 9 + (100 - i.l) * 0.85), 0.16, 0.3, c[3]);
    if (i.l < 26 && i.ch < 60) return make(i, i.l + 8, 0.14, 0.35, c[3]);
    return c;
  }

  function mapText(c) {
    if (!c[3]) return c;
    var i = info(c);
    if (i.l >= 62) return c;
    return make(i, Math.max(64, Math.min(95, 100 - i.l * 0.75)), 0.1, 0.7, c[3]);
  }

  function mapBorder(c) {
    if (!c[3]) return c;
    var i = info(c);
    if (i.l >= 50) return make(i, Math.min(40, 18 + (100 - i.l) * 0.5), 0.12, 0.3, c[3]);
    return make(i, Math.max(55, Math.min(85, 100 - i.l * 0.75)), 0.1, 0.5, c[3]);
  }

  function mapShadow(c) {
    if (!c[3]) return c;
    return info(c).l >= 60 ? [16, 25, 22, c[3]] : c; // light glows/inset highlights would read as white lines
  }

  var MAPPERS = { bg: mapBg, text: mapText, border: mapBorder, shadow: mapShadow };

  function mapValue(value, role) {
    var changed = false;
    var next = String(value).replace(COLOR_RE, function (token) {
      var c = parseColor(token);
      if (!c) return token;
      var mapped = fmt(MAPPERS[role](c));
      if (mapped !== fmt(c)) changed = true;
      return mapped;
    });
    return changed ? next : null;
  }

  /* How each custom property is actually used decides how it is mapped:
     a "--dd-dark" that only paints backgrounds is a surface, not a text colour. */
  var varUsage = {};
  var VAR_REF = /var\(\s*(--[\w-]+)/g;
  var USAGE_PROPS = {
    'background': 'bg', 'background-color': 'bg', 'background-image': 'bg',
    'color': 'text', 'fill': 'text', 'stroke': 'text', 'caret-color': 'text', 'text-decoration-color': 'text', '-webkit-text-fill-color': 'text',
    'border': 'border', 'border-top': 'border', 'border-right': 'border', 'border-bottom': 'border', 'border-left': 'border',
    'border-color': 'border', 'border-top-color': 'border', 'border-right-color': 'border', 'border-bottom-color': 'border',
    'border-left-color': 'border', 'outline': 'border', 'outline-color': 'border'
  };

  var varDefs = {};

  function noteUsage(st) {
    for (var d = 0; d < st.length; d++) {
      var own = st[d];
      if (own.indexOf('--') !== 0) continue;
      var dc = parseColor(st.getPropertyValue(own).trim());
      if (dc) varDefs[own] = dc;
    }
    for (var prop in USAGE_PROPS) {
      var v = st.getPropertyValue(prop);
      if (!v || v.indexOf('var(') < 0) continue;
      var m;
      VAR_REF.lastIndex = 0;
      while ((m = VAR_REF.exec(v))) {
        var u = varUsage[m[1]] || (varUsage[m[1]] = {});
        u[USAGE_PROPS[prop]] = true;
      }
    }
  }

  function isSplit(name) {
    var used = varUsage[name];
    return !!(used && used.bg && used.text);
  }

  // A colour token used both as a surface and as text cannot have one dark value:
  // its definition stays, and every rule that uses it gets the value its role needs.
  var VAR_CALL = /var\(\s*(--[\w-]+)\s*(?:,(?:[^()]|\([^()]*\))*)?\)/g;

  function substituteSplit(value, role) {
    var changed = false;
    var next = String(value).replace(VAR_CALL, function (all, name) {
      if (!isSplit(name) || !varDefs[name]) return all;
      changed = true;
      return fmt(MAPPERS[role](varDefs[name]));
    });
    return changed ? next : null;
  }

  function varColor(value) {
    if (!value || value.indexOf('var(') < 0) return null;
    var m;
    VAR_CALL.lastIndex = 0;
    while ((m = VAR_CALL.exec(value))) if (varDefs[m[1]]) return varDefs[m[1]];
    return null;
  }

  function varRole(name, c) {
    var used = varUsage[name];
    if (used) {
      if (used.bg && used.text) return null;
      var roles = Object.keys(used);
      if (roles.length === 1) return roles[0];
      if (roles.length === 2 && used.border && used.text) return 'text';
    }
    var n = name.toLowerCase();
    if (/(line|border|divider|rule|stroke|hairline|outline|separator)/.test(n)) return 'border';
    if (/(ink|text|fg|foreground|muted|title|heading|copy|label|meta|subtle|caption|font-color|body-color)/.test(n)) return 'text';
    if (/(bg|background|paper|surface|card|panel|soft|base|wash|tint|canvas|page|cream|sand|stone|shell|tile|chip|pill|field|input)/.test(n)) return 'bg';
    var i = info(c);
    if (i.l >= 80 && i.ch < 40) return 'bg';
    if (i.l <= 35) return 'text';
    return null;
  }

  /* ---------- 1) dark mode generator ---------- */
  var LONGHANDS = {
    'color': 'text', 'background-color': 'bg', 'background-image': 'bg',
    'border-top-color': 'border', 'border-right-color': 'border', 'border-bottom-color': 'border', 'border-left-color': 'border',
    'outline-color': 'border', 'column-rule-color': 'border', 'fill': 'text', 'stroke': 'text',
    'caret-color': 'text', 'text-decoration-color': 'text', 'box-shadow': 'shadow'
  };
  var SHORTHANDS = {
    'background': 'bg', 'border': 'border', 'border-top': 'border', 'border-right': 'border',
    'border-bottom': 'border', 'border-left': 'border', 'border-color': 'border', 'outline': 'border'
  };

  function splitSelectors(text) {
    var out = [], depth = 0, cur = '';
    for (var i = 0; i < text.length; i++) {
      var ch = text.charAt(i);
      if (ch === '(' || ch === '[') depth++;
      else if (ch === ')' || ch === ']') depth--;
      if (ch === ',' && depth === 0) { out.push(cur.trim()); cur = ''; } else cur += ch;
    }
    if (cur.trim()) out.push(cur.trim());
    return out;
  }

  function prefixSelector(sel) {
    var rest = sel.trim();
    var htmlPart = '';
    var bodyPart = '';
    var m = rest.match(/^(?:html|:root)((?:[.#\[:][^\s>+~]*)?)/i);
    if (m) {
      htmlPart = m[1] || '';
      rest = rest.slice(m[0].length).replace(/^\s*>?\s*/, '');
    }
    var b = rest.match(/^body((?:[.#\[:][^\s>+~]*)?)/i);
    if (b) {
      bodyPart = b[1] || '';
      rest = rest.slice(b[0].length).replace(/^\s*>?\s*/, '');
    }
    return PH + htmlPart + ' body' + bodyPart + PB + (rest ? ' ' + rest : '');
  }

  function isOpaqueDark(c) {
    if (!c || c[3] < 0.5) return false;
    var i = info(c);
    return i.l < 26 && i.ch < 60;
  }

  function processRule(rule, cond, out) {
    var text = rule.selectorText;
    var st = rule.style;
    if (!text || !st || !st.length || SKIP_SELECTOR.test(text)) return;
    var selectors = splitSelectors(text).filter(function (s) { return s && !MEDIA_SELECTOR.test(s); });
    if (!selectors.length) return;

    var decl = {};
    var bgC = parseColor(st.getPropertyValue('background-color'));
    if (!bgC) {
      var shorthandBg = st.getPropertyValue('background') || st.getPropertyValue('background-color');
      bgC = varColor(shorthandBg);
      var firstBg = !bgC && shorthandBg && shorthandBg.indexOf('var(') >= 0 && shorthandBg.match(COLOR_RE);
      if (firstBg) bgC = parseColor(firstBg[0]);
    }
    var colorC = parseColor(st.getPropertyValue('color'));
    if (!colorC) {
      colorC = varColor(st.getPropertyValue('color'));
      var colorVar = !colorC && st.getPropertyValue('color').match(COLOR_RE);
      if (colorVar) colorC = parseColor(colorVar[0]);
    }
    var asButton = BUTTON_SELECTOR.test(text) && isOpaqueDark(bgC);
    var keepText = bgC && bgC[3] >= 0.5 && info(bgC).l >= 55 && info(bgC).ch > 45; // text on a kept accent

    for (var k = 0; k < st.length; k++) {
      var name = st[k];
      if (name.indexOf('--') === 0) {
        var raw = st.getPropertyValue(name).trim();
        var vc = parseColor(raw);
        if (!vc) continue;
        var role = varRole(name, vc);
        if (!role) continue;
        var nv = fmt(MAPPERS[role](vc));
        if (nv !== fmt(vc)) decl[name] = nv;
        continue;
      }
      var r = LONGHANDS[name];
      if (!r) continue;
      var v = st.getPropertyValue(name);
      if (!v) continue;
      if (asButton && name === 'background-color') { decl[name] = /:hover|:focus/.test(text) ? ACCENT_HOVER : ACCENT; continue; }
      if (asButton && name === 'color') { decl[name] = ACCENT_INK; continue; }
      if (asButton && /^border-.*-color$/.test(name)) { decl[name] = ACCENT; continue; }
      if (v.search(COLOR_RE) < 0) continue;
      if (keepText && (r === 'text')) continue;
      var mapped = mapValue(v, r);
      if (mapped) decl[name] = mapped;
    }
    if (asButton && !decl.color && colorC && info(colorC).l > 70) decl.color = ACCENT_INK;
    for (var sh in SHORTHANDS) {
      var sv = st.getPropertyValue(sh);
      if (!sv || sv.indexOf('var(') < 0) continue;
      if (asButton && sh === 'background') { decl.background = /:hover|:focus/.test(text) ? ACCENT_HOVER : ACCENT; continue; }
      if (sv.search(COLOR_RE) < 0) continue;
      var sm = mapValue(sv, SHORTHANDS[sh]);
      if (sm) decl[sh] = sm;
    }
    for (var up in USAGE_PROPS) {
      var role2 = USAGE_PROPS[up];
      if (asButton && (role2 === 'bg' || up === 'color')) continue;
      var uv = st.getPropertyValue(up);
      if (!uv || uv.indexOf('var(') < 0) continue;
      var sub = substituteSplit(decl[up] || uv, role2);
      if (sub) decl[up] = sub;
    }
    if (!Object.keys(decl).length) return;

    var group = out[cond] || (out[cond] = {});
    selectors.forEach(function (s) {
      var key = prefixSelector(s);
      var target = group[key] || (group[key] = {});
      for (var p in decl) target[p] = decl[p];
    });
  }

  function walkRules(rules, cond, list) {
    for (var i = 0; i < rules.length; i++) {
      var r = rules[i];
      try {
        if (r.type === 1) { if (r.style) noteUsage(r.style); list.push([r, cond]); }
        else if (r.type === 4) walkRules(r.cssRules, cond + '@media ' + r.media.mediaText + '\u0001', list);
        else if (r.type === 12) walkRules(r.cssRules, cond + '@supports ' + r.conditionText + '\u0001', list);
        else if (r.cssRules && r.type !== 7) walkRules(r.cssRules, cond, list);
      } catch (e) { /* ignore one broken rule */ }
    }
  }

  function sheetIsOurs(sheet) {
    var node = sheet.ownerNode;
    if (node && typeof node.id === 'string' && node.id.indexOf('dd-ap-') === 0) return true;
    var href = sheet.href || '';
    return /dd-appearance-(v1|fixes)/.test(href);
  }

  var processedSheets = typeof WeakSet === 'function' ? new WeakSet() : null;

  function collect(sheets) {
    var out = {};
    var list = [];
    for (var i = 0; i < sheets.length; i++) {
      var sheet = sheets[i];
      if (!sheet || sheetIsOurs(sheet)) continue;
      if (processedSheets && processedSheets.has(sheet)) continue;
      var rules;
      try { rules = sheet.cssRules; } catch (e) { continue; } // cross-origin (fonts)
      if (!rules) continue;
      walkRules(rules, '', list);
      if (processedSheets) processedSheets.add(sheet);
    }
    for (var j = 0; j < list.length; j++) {
      try { processRule(list[j][0], list[j][1], out); } catch (e) { /* ignore one broken rule */ }
    }
    return out;
  }

  function serialize(map) {
    var css = '';
    Object.keys(map).forEach(function (cond) {
      var body = '';
      var group = map[cond];
      Object.keys(group).forEach(function (sel) {
        var d = group[sel];
        var parts = [];
        for (var p in d) parts.push(p + ':' + d[p] + '!important');
        if (parts.length) body += sel + '{' + parts.join(';') + '}\n';
      });
      if (!body) return;
      var conds = cond ? cond.split('\u0001').filter(Boolean) : [];
      for (var i = conds.length - 1; i >= 0; i--) body = conds[i] + '{\n' + body + '}\n';
      css += body;
    });
    return css;
  }

  function mergeInto(target, src) {
    var changed = false;
    Object.keys(src).forEach(function (cond) {
      var g = target[cond] || (target[cond] = {});
      Object.keys(src[cond]).forEach(function (sel) {
        var d = g[sel] || (g[sel] = {});
        var s = src[cond][sel];
        for (var p in s) if (d[p] !== s[p]) { d[p] = s[p]; changed = true; }
      });
    });
    return changed;
  }

  var genStyle = null;
  var pageMap = {};
  var cacheTimer = null;

  function ensureStyle() {
    if (genStyle && genStyle.isConnected) return genStyle;
    genStyle = document.createElement('style');
    genStyle.id = 'dd-ap-darkgen';
    document.head.appendChild(genStyle);
    return genStyle;
  }

  function generateDark(sheets) {
    var found = collect(sheets || document.styleSheets);
    if (!mergeInto(pageMap, found)) return;
    ensureStyle().textContent = serialize(pageMap);
    clearTimeout(cacheTimer);
    cacheTimer = setTimeout(saveCache, 1200);
  }

  function saveCache() {
    try {
      var stored = JSON.parse(localStorage.getItem(MAP_KEY) || 'null');
      if (!stored || !stored.t || Date.now() - stored.t > CACHE_DAYS * 864e5) stored = { t: Date.now(), m: {} };
      mergeInto(stored.m, pageMap);
      var css = serialize(stored.m);
      if (css.length > MAX_CACHE) { stored = { t: Date.now(), m: pageMap }; css = serialize(pageMap); }
      localStorage.setItem(MAP_KEY, JSON.stringify(stored));
      localStorage.setItem(CSS_KEY, css);
    } catch (e) { /* storage full or blocked: generation still works per page */ }
  }

  /* inline style="background:…" surfaces (not reachable through stylesheets) */
  var originals = typeof WeakMap === 'function' ? new WeakMap() : null;
  var touched = new Set();

  function remember(el, prop) {
    if (!originals) return;
    var rec = originals.get(el);
    if (!rec) { rec = {}; originals.set(el, rec); }
    if (!(prop in rec)) rec[prop] = [el.style.getPropertyValue(prop), el.style.getPropertyPriority(prop)];
    touched.add(el);
  }

  function restore(el, props) {
    var rec = originals && originals.get(el);
    if (!rec) return;
    props.forEach(function (prop) {
      if (!(prop in rec)) return;
      var v = rec[prop];
      if (v[0]) el.style.setProperty(prop, v[0], v[1]); else el.style.removeProperty(prop);
      delete rec[prop];
    });
  }

  function darkenInlineSurfaces(scope) {
    var list = (scope || document).querySelectorAll('[style*="background"],[style*="--"]');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el.hasAttribute('data-dd-ap-surface')) continue;
      if (el.closest(EXCLUDE_TREE) || el.closest('.shopify-section-group-header-group,.shopify-section-group-footer-group')) continue;
      if (MEDIA_SELECTOR.test(typeof el.className === 'string' ? el.className : '')) continue;
      var props = [];
      var c = parseColor(el.style.getPropertyValue('background-color'));
      if (c) {
        var m = fmt(mapBg(c));
        if (m !== fmt(c)) {
          remember(el, 'background-color');
          el.style.setProperty('background-color', m, 'important');
          props.push('background-color');
        }
      }
      for (var k = 0; k < el.style.length; k++) {
        var prop = el.style[k];
        if (prop.indexOf('--') !== 0) continue;
        var vc = parseColor(el.style.getPropertyValue(prop));
        if (!vc) continue;
        var role = varRole(prop, vc);
        if (!role) continue;
        var nv = fmt(MAPPERS[role](vc));
        if (nv === fmt(vc)) continue;
        remember(el, prop);
        el.style.setProperty(prop, nv);
        props.push(prop);
      }
      if (!props.length) continue;
      el.__ddApSurface = props;
      el.setAttribute('data-dd-ap-surface', '');
    }
  }

  function undoInlineSurfaces() {
    var list = document.querySelectorAll('[data-dd-ap-surface]');
    for (var i = 0; i < list.length; i++) {
      restore(list[i], list[i].__ddApSurface || ['background-color']);
      list[i].__ddApSurface = null;
      list[i].removeAttribute('data-dd-ap-surface');
    }
  }

  /* ---------- 2) readability guard ---------- */
  function lum(c) {
    return [c[0], c[1], c[2]].map(function (v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    }).reduce(function (s, v, i) { return s + v * [0.2126, 0.7152, 0.0722][i]; }, 0);
  }

  function blend(top, bottom) {
    var a = top[3];
    return [top[0] * a + bottom[0] * (1 - a), top[1] * a + bottom[1] * (1 - a), top[2] * a + bottom[2] * (1 - a), 1];
  }

  function averageStops(img) {
    var stops = img.match(COLOR_RE);
    if (!stops) return null;
    var acc = [0, 0, 0, 0], n = 0;
    stops.forEach(function (s) { var c = parseColor(s); if (c) { acc[0] += c[0]; acc[1] += c[1]; acc[2] += c[2]; acc[3] += c[3]; n++; } });
    return n ? [acc[0] / n, acc[1] / n, acc[2] / n, acc[3] / n] : null;
  }

  function pageBase() {
    var c = parseColor(getComputedStyle(document.body).backgroundColor);
    if (c && c[3] > 0.5) return [c[0], c[1], c[2], 1];
    return root.getAttribute('data-dd-theme') === 'dark' ? [16, 25, 22, 1] : [255, 255, 255, 1];
  }

  function makeBgResolver() {
    var memo = new Map();
    var base = pageBase();
    function resolve(el) {
      if (!el || el.nodeType !== 1) return base;
      if (memo.has(el)) return memo.get(el);
      var result;
      if (/^(IMG|VIDEO|PICTURE|CANVAS)$/.test(el.tagName)) result = null;
      else {
        var cs = getComputedStyle(el);
        var bi = cs.backgroundImage;
        var layer = parseColor(cs.backgroundColor);
        if (bi && bi !== 'none' && /url\(/i.test(bi)) result = null; // text over photography
        else {
          var grad = bi && bi !== 'none' ? averageStops(bi) : null;
          var below;
          var opaque = (grad && grad[3] >= 0.95) || (layer && layer[3] >= 0.95);
          if (!opaque) {
            below = resolve(el.parentElement);
            if (below === null) { memo.set(el, null); return null; }
          }
          var acc = opaque ? [0, 0, 0, 1] : below;
          if (layer && layer[3] > 0) acc = layer[3] >= 0.95 ? [layer[0], layer[1], layer[2], 1] : blend(layer, acc);
          if (grad && grad[3] > 0) acc = grad[3] >= 0.95 ? [grad[0], grad[1], grad[2], 1] : blend(grad, acc);
          result = acc;
        }
      }
      memo.set(el, result);
      return result;
    }
    return resolve;
  }

  // Text laid over a photo (slider counters, badges on product images): its real backdrop
  // is the picture, not the ancestors' colour, so the guard leaves it alone.
  function overImage(el) {
    var a = el;
    for (var i = 0; a && a !== document.body && i < 6; i++, a = a.parentElement) {
      var acs = getComputedStyle(a);
      var own = parseColor(acs.backgroundColor);
      if (own && own[3] >= 0.5) return false; // a badge/pill brings its own backdrop
      var pos = acs.position;
      if (pos !== 'absolute' && pos !== 'fixed') continue;
      var p = a.parentElement;
      if (p && p.querySelector('img,picture,video,canvas') && !a.querySelector('img,picture,video,canvas')) return true;
    }
    return false;
  }

  function guardActive() {
    return root.getAttribute('data-dd-theme') === 'dark' || root.getAttribute('data-dd-contrast') === 'high';
  }

  function clearGuard() {
    var list = document.querySelectorAll('[data-dd-ap-fix]');
    for (var i = 0; i < list.length; i++) {
      restore(list[i], ['color', '-webkit-text-fill-color']);
      list[i].removeAttribute('data-dd-ap-fix');
    }
  }

  function textHosts(scope) {
    var set = new Set();
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) { return /\S/.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP; }
    });
    var n;
    while ((n = walker.nextNode())) {
      var p = n.parentElement;
      if (p && !set.has(p) && !p.closest(EXCLUDE_TREE)) set.add(p);
    }
    var controls = scope.querySelectorAll ? scope.querySelectorAll('input:not([type=hidden]):not([type=checkbox]):not([type=radio]):not([type=range]),select,textarea,button') : [];
    for (var i = 0; i < controls.length; i++) if (!controls[i].closest(EXCLUDE_TREE)) set.add(controls[i]);
    if (scope.nodeType === 1 && scope.matches && scope.matches('input,select,textarea,button') && !scope.closest(EXCLUDE_TREE)) set.add(scope);
    return Array.from(set);
  }

  function runGuard(scope) {
    if (!guardActive() || !document.body) return;
    var resolve = makeBgResolver();
    var hosts = textHosts(scope || document.body);
    var fixes = [];
    for (var i = 0; i < hosts.length; i++) {
      var el = hosts[i];
      if (el.hasAttribute('data-dd-ap-fix') || el.closest(GUARD_EXCLUDE)) continue;
      if (!el.getClientRects().length) continue;
      var cs = getComputedStyle(el);
      if (cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.1) continue;
      var fg = parseColor(cs.webkitTextFillColor && cs.webkitTextFillColor !== cs.color ? cs.webkitTextFillColor : cs.color);
      if (!fg || fg[3] < 0.1) continue;
      var bg = resolve(el);
      if (!bg) continue;
      var shown = fg[3] < 1 ? blend(fg, bg) : fg;
      var l1 = lum(shown), l2 = lum(bg);
      var ratio = (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05);
      if (ratio >= 3 || overImage(el)) continue;
      fixes.push([el, lum(bg) > 0.35 ? DARK_INK : LIGHT_INK]);
    }
    fixes.forEach(function (f) {
      remember(f[0], 'color');
      remember(f[0], '-webkit-text-fill-color');
      f[0].style.setProperty('color', f[1], 'important');
      f[0].style.setProperty('-webkit-text-fill-color', f[1], 'important');
      f[0].setAttribute('data-dd-ap-fix', '');
    });
  }

  /* ---------- 3) text size + 4) clamp safety ---------- */
  var scaled = new Set();
  var clampFixed = new Set();

  function unscale(list) {
    list.forEach(function (el) { restore(el, ['font-size', 'line-height']); scaled.delete(el); });
  }

  function unclamp() {
    clampFixed.forEach(function (el) { restore(el, ['display', '-webkit-box-orient', 'max-height']); });
    clampFixed.clear();
  }

  function applyText(scope) {
    var mode = root.getAttribute('data-dd-text') || 'regular';
    var factor = TEXT_SCALE[mode] || 1;
    var relaxed = root.getAttribute('data-dd-spacing') === 'relaxed';
    if (factor === 1 && !relaxed && !scaled.size && !clampFixed.size) return;
    var targets = textHosts(scope || document.body);
    if (!scope) { unscale(Array.from(scaled)); unclamp(); }
    else unscale(targets.filter(function (el) { return scaled.has(el); }));
    if (factor === 1 && !relaxed) return;

    var measured = [];
    if (factor !== 1) {
      root.setAttribute('data-dd-text', 'regular');
      for (var i = 0; i < targets.length; i++) {
        var cs = getComputedStyle(targets[i]);
        measured.push([parseFloat(cs.fontSize), cs.lineHeight]);
      }
      root.setAttribute('data-dd-text', mode);
      targets.forEach(function (el, idx) {
        var fs = measured[idx][0];
        if (!fs) return;
        var k = el.closest('.shopify-section-group-header-group') ? Math.min(factor, HEADER_SCALE_MAX) : factor;
        remember(el, 'font-size');
        remember(el, 'line-height');
        el.style.setProperty('font-size', (fs * k).toFixed(2) + 'px', 'important');
        var lh = parseFloat(measured[idx][1]);
        if (lh && /px$/.test(measured[idx][1])) el.style.setProperty('line-height', (lh * k).toFixed(2) + 'px', 'important');
        scaled.add(el);
      });
    }
    // never cut line-clamped copy by a fixed pixel height
    targets.forEach(function (el) {
      if (el.clientHeight < 1 || el.scrollHeight <= el.clientHeight + 1) return;
      var cs = getComputedStyle(el);
      if (!/px$/.test(cs.maxHeight) || (cs.overflowY !== 'hidden' && cs.overflow !== 'hidden')) return;
      var clamp = cs.webkitLineClamp;
      if (!clamp || clamp === 'none') return;
      remember(el, 'display');
      remember(el, '-webkit-box-orient');
      remember(el, 'max-height');
      el.style.setProperty('display', '-webkit-box', 'important');
      el.style.setProperty('-webkit-box-orient', 'vertical', 'important');
      el.style.setProperty('max-height', 'none', 'important');
      clampFixed.add(el);
    });
  }

  /* ---------- orchestration ---------- */
  function state() {
    return ['data-dd-theme', 'data-dd-text', 'data-dd-contrast', 'data-dd-spacing', 'data-dd-links'].map(function (a) {
      return root.getAttribute(a) || '';
    }).join('|');
  }

  var last = '';
  var guardTimer = null;

  function afterPaint(fn) {
    requestAnimationFrame(function () { requestAnimationFrame(fn); });
  }

  // Colour changes from a theme switch must land at once: sections with
  // "transition: background …" would otherwise fade from light to dark (a visible flash)
  // and the readability guard would measure half-way colours.
  function withoutTransitions(fn) {
    var s = document.createElement('style');
    s.id = 'dd-ap-notrans';
    s.textContent = '*,*::before,*::after{transition:none!important}';
    document.head.appendChild(s);
    try { fn(); } finally {
      void document.documentElement.offsetHeight;
      if (document.body) getComputedStyle(document.body).color;
      setTimeout(function () { if (s.parentNode) s.parentNode.removeChild(s); }, 0);
    }
  }

  function scheduleGuard(scope) {
    clearTimeout(guardTimer);
    guardTimer = setTimeout(function () {
      var run = function () { runGuard(scope); };
      if (window.requestIdleCallback) requestIdleCallback(run, { timeout: 800 }); else run();
    }, 120);
  }

  function refresh(force) {
    var now = state();
    if (!force && now === last) return;
    var prev = last.split('|');
    last = now;
    var dark = root.getAttribute('data-dd-theme') === 'dark';
    var cur = now.split('|');
    var plain = !dark && (!cur[1] || cur[1] === 'regular') && cur[3] !== 'relaxed' && !scaled.size && !clampFixed.size &&
      !document.querySelector('[data-dd-ap-surface],[data-dd-ap-fix]');
    if (plain) { // default look: nothing to undo, nothing to add
      if (guardActive()) afterPaint(function () { scheduleGuard(); });
      return;
    }
    withoutTransitions(function () {
      if (dark) { generateDark(); darkenInlineSurfaces(document.body); } else undoInlineSurfaces();
      if (force || prev[1] !== cur[1] || prev[3] !== cur[3]) applyText();
      clearGuard();
    });
    afterPaint(function () { scheduleGuard(); });
  }

  var pendingNodes = new Set();
  var nodeTimer = null;

  function flushNodes() {
    var nodes = Array.from(pendingNodes);
    pendingNodes.clear();
    var sheets = [];
    nodes.forEach(function (n) {
      if (n.sheet) sheets.push(n.sheet);
      if (n.querySelectorAll) Array.prototype.forEach.call(n.querySelectorAll('style,link[rel=stylesheet]'), function (s) { if (s.sheet) sheets.push(s.sheet); });
    });
    var dark = root.getAttribute('data-dd-theme') === 'dark';
    if (dark && sheets.length) withoutTransitions(function () { generateDark(sheets); });
    nodes.forEach(function (n) {
      if (n.nodeType !== 1 || !n.isConnected || n.closest(EXCLUDE_TREE)) return;
      if (dark) darkenInlineSurfaces(n);
      if ((root.getAttribute('data-dd-text') || 'regular') !== 'regular' || root.getAttribute('data-dd-spacing') === 'relaxed') applyText(n);
    });
    if (guardActive()) afterPaint(function () { nodes.forEach(function (n) { if (n.isConnected && n.nodeType === 1) runGuard(n); }); });
  }

  function watch() {
    new MutationObserver(function () { refresh(false); }).observe(root, {
      attributes: true,
      attributeFilter: ['data-dd-theme', 'data-dd-text', 'data-dd-contrast', 'data-dd-spacing', 'data-dd-links']
    });
    new MutationObserver(function (records) {
      records.forEach(function (rec) {
        Array.prototype.forEach.call(rec.addedNodes, function (n) {
          if (n.nodeType !== 1) return;
          if (typeof n.id === 'string' && n.id.indexOf('dd-ap-') === 0) return;
          if (n.tagName === 'LINK' && n.rel === 'stylesheet' && !n.sheet) {
            n.addEventListener('load', function () { pendingNodes.add(n); clearTimeout(nodeTimer); nodeTimer = setTimeout(flushNodes, 120); }, { once: true });
            return;
          }
          pendingNodes.add(n);
        });
      });
      if (pendingNodes.size) { clearTimeout(nodeTimer); nodeTimer = setTimeout(flushNodes, 120); }
    }).observe(document.documentElement, { childList: true, subtree: true });

    var resizeTimer = null;
    var lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if ((root.getAttribute('data-dd-text') || 'regular') !== 'regular' || root.getAttribute('data-dd-spacing') === 'relaxed') applyText();
        if (guardActive()) { clearGuard(); scheduleGuard(); }
      }, 250);
    });
    window.addEventListener('load', function () { if (guardActive()) scheduleGuard(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () {
      if ((root.getAttribute('data-dd-text') || 'regular') !== 'regular') applyText();
    });
  }

  function start() {
    refresh(true);
    watch();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
